import { css } from 'lit'
import { SCREENS } from '@cloudsuite/mosaic-shared/styles/breakpoints.js'
import { csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'

export const styles = css`
  :host([hide-divider]) header {
    row-gap: 0;
  }

  header {
    display: grid;
    grid-template-areas:
      "top"
      "divider"
      "bottom";
    row-gap: ${csSpacing.spacing05};
  }
  
  .top {
    display: grid;
    grid-area: top;
    grid-template-areas:
      "heading"
      "meta-data"
      "chips";
    row-gap: ${csSpacing.spacing05};

    @media(min-width: ${SCREENS.extraSmall}) {
      grid-template-areas:
        "heading chips"
        "meta-data chips";
      grid-template-columns: 1fr auto;
    }

    &.no-meta-data {
      grid-template-areas:
        "heading"
        "chips";
      row-gap: ${csSpacing.spacing06};

      @media(min-width: ${SCREENS.extraSmall}) {
        grid-template-areas: "heading chips";
      }
    }

    .chips {
      grid-area: chips;
      align-self: start;
      justify-self: stretch;
      width: 100%;
      --cs-gutter-x: 0;

      ::slotted([slot="top-action"]) {
        width: 100%;
      }

      @media(min-width: ${SCREENS.extraSmall}) {
        justify-self: end;
        width: auto;

        ::slotted([slot="top-action"]) {
          width: auto;
        }
      }
    }

    .heading {
      display: grid;
      grid-area: heading;
      grid-template-areas: "heading-text heading-text";
      
      &.heading-icon {
        grid-template-areas: "heading-icon heading-text";
        grid-template-columns: auto 1fr;
        align-items: center;
        column-gap: ${csSpacing.spacing05};

        .heading-icon {
          --cse-icon-size: var(--cs-font-heading-1-font-size-mobile, 32px);

          @media(min-width: ${SCREENS.small}) {
            --cse-icon-size: var(--cs-font-heading-1-font-size, 36px);
          }
        }
      }

      .heading-text {
        grid-area: heading-text;
      }
    }
    
    .meta-data {
      grid-area: meta-data;
      align-items: center;
    }
  }
  
  .divider {
    grid-area: divider;
  }
  
  .bottom {
    display: grid;
    grid-area: bottom;
    grid-template-areas: "input buttons";
    grid-template-columns: auto 1fr;
  }

  .meta-data {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-area: meta-data;
    gap: ${csSpacing.spacing05};
    
    .badge {
      display: inline-block;
    }
 
    .date {
      display: inline-block;
      --cse-text-color: var(--csc-account-header-date-color, ${csColorText.muted});
    }
  }
  
  cse-divider {
    grid-area: divider;
  }
  
  .bottom-buttons {
    grid-area: buttons;
    display: flex;
    justify-content: stretch;

    ::slotted(*) {
      width: 100%;
    }

    @media(min-width: ${SCREENS.extraSmall}) {
      justify-content: flex-end;

      ::slotted(*) {
        width: auto;
      }
    }
  }
`
